import styled from "@emotion/styled"
import SectionWrapper from "../../components/section-wrapper/section-wrapper.component"
import { Container, Typography } from "@mui/material"
import CustomImage from "../../components/custom-image/custom-image.component"

export const Section = styled(SectionWrapper)`
  padding-top: ${({ theme }) => theme.typography.pxToRem(140)};
  padding-bottom: ${({ theme }) => theme.typography.pxToRem(140)};

  ${({ theme }) => theme.breakpoints.down("md")} {
    padding-top: ${({ theme }) => theme.typography.pxToRem(75)};
    padding-bottom: 1rem;
  }
`

export const Wrapper = styled(Container)``

export const Title = styled(Typography)`
  color: ${({ theme }) => theme.palette.tertiary.light};
  font-size: ${({ theme }) => theme.typography.pxToRem(14)};
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.42px;
  text-transform: uppercase;
  margin-bottom: 0.5rem;

  &.notification {
    color: ${({ theme }) => theme.palette.primary.dark};
    font-style: normal;
    font-weight: 500;
    line-height: ${({ theme }) => theme.typography.pxToRem(16.28)};
    letter-spacing: -0.326px;
    text-transform: capitalize;
  }

  ${({ theme }) => theme.breakpoints.down("md")} {
    font-size: ${({ theme }) => theme.typography.pxToRem(15)};
    letter-spacing: 0.45px;
  }
`

export const Description = styled(Typography)`
  color: ${({ theme }) => theme.palette.primary.main};
  font-size: ${({ theme }) => theme.typography.pxToRem(22)};
  font-style: normal;
  font-weight: 400;
  line-height: ${({ theme }) => theme.typography.pxToRem(30)};
  letter-spacing: -0.048px;
  opacity: 0.8;

  &.notification {
    color: ${({ theme }) => theme.palette.primary.dark};
    font-size: ${({ theme }) => theme.typography.pxToRem(14)};
    line-height: ${({ theme }) => theme.typography.pxToRem(20)};
    letter-spacing: normal;
  }

  ${({ theme }) => theme.breakpoints.up("md")} {
    max-width: 542px;
    font-size: ${({ theme }) => theme.typography.pxToRem(24)};
    line-height: ${({ theme }) => theme.typography.pxToRem(36)};
  }
`

export const ButtonsContainer = styled.div`
  margin-top: ${({ theme }) => theme.typography.pxToRem(52)};
  display: flex;
  align-items: center;
  column-gap: 0.7rem;
`

export const ImageContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: flex-end;

  ${({ theme }) => theme.breakpoints.down("md")} {
    margin-top: ${({ theme }) => theme.typography.pxToRem(130)};
    justify-content: center;
  }
`

export const Image = styled(CustomImage)`
  width: 100% !important;
  height: 100% !important;
  .gatsby-image-wrapper {
    min-height: 323px;
  }
  img {
    border-radius: 10px;
    overflow: hidden;
  }
`

export const Time = styled(Typography)`
  color: #607370;
  font-size: ${({ theme }) => theme.typography.pxToRem(11)};
  font-style: normal;
  font-weight: 400;
  line-height: ${({ theme }) => theme.typography.pxToRem(11)};
  letter-spacing: -0.326px;
  opacity: 0.5;
`
export const NotificationWrapper = styled.div`
  position: absolute;
  top: 20%;
  left: -60px;

  ${({ theme }) => theme.breakpoints.down(1320)} {
    left: 15%;
  }

  ${({ theme }) => theme.breakpoints.down("md")} {
    top: -15%;
    left: 25%;
  }

  ${({ theme }) => theme.breakpoints.down("sm")} {
    top: -25%;
    left: 5%;
  }
`

export const NotificationContainer = styled.div`
  border: 1.035px solid #dae2ef;
  background-color: ${({ theme }) => theme.palette.primary.light};
  box-shadow: 0px 4px 16px 0px rgba(5, 11, 68, 0.08);
  border-radius: 11.065px;
  padding: 1.2rem;
  position: relative;
  max-width: 291px;
`

export const Logo = styled(CustomImage)`
  width: 52px;
  height: 52px;
  position: absolute;
  top: -20px;
  right: 20px;
`
